import React, { useEffect, useState } from "react";
import axios from "axios";
import "./styles.css";

export default function RecentLoggedInUsers({ refreshKey }) {
    const [activeUsers, setActiveUsers] = useState(null);
    const [tooltip, setTooltip] = useState("Number of users who logged in within the last day.");
    const [error, setError] = useState("");

    // You can change this variable to "day", "week", "month", or "year"
    const windowKey = "day";

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/recent-logged-in-users`, {
            withCredentials: true
        })
            .then(res => {
                if (res.data && res.data.success) {
                    setActiveUsers(res.data.recent_logins[windowKey]);
                    setTooltip(res.data.tooltip);
                    setError("");
                } else {
                    setError("Could not load active user count.");
                    setActiveUsers(null);
                }
            })
            .catch(() => {
                setError("Could not load active user count.");
                setActiveUsers(null);
            });
    }, [refreshKey, windowKey]);

    return (
        <div className="user-profile-container" style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div className="tooltip-icon" title={tooltip}>
                {activeUsers !== null && !error
                    ? `${activeUsers} current active users 🛈`
                    : error}
            </div>
        </div>
    );
}